(function($) {
    'use strict';

    var FLIPBOX = '.ttgNCEFlipBox';

    // Geraete ohne echten Hover (Touch) duerfen die Karte nicht per mouseenter umdrehen
    function isTouchDevice() {
        if (window.matchMedia) {
            return !window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        }

        return ('ontouchstart' in window);
    }

    // inert nimmt die abgewandte Seite in einem Schritt aus Fokusreihenfolge und
    // Accessibility-Tree - auch fuer Inhalte, die Redakteure im RTE einbauen (WCAG 4.1.2)
    function setInert($elements, inert) {
        $elements.each(function() {
            if (inert) {
                this.inert = true;
                this.setAttribute('inert', 'inert');
            } else {
                this.inert = false;
                this.removeAttribute('inert');
            }
        });
    }

    // Nur tatsaechlich scrollbare Bereiche bekommen einen Tabstopp (WCAG 2.1.1),
    // sonst entstehen Fokusstationen ohne Funktion
    function updateScrollableTabindex($elements, active) {
        $elements.each(function() {
            var scrollable = this.scrollHeight > this.clientHeight + 1;
            this.setAttribute('tabindex', (active && scrollable) ? '0' : '-1');
        });
    }

    function setFlipState($card, flipped) {
        var $wrapper = $card.closest(FLIPBOX);
        var $front = $card.find('.front');
        var $back = $card.find('.back');

        // Fokus retten, bevor die aktive Seite inert wird
        if (!flipped && $back.length && $.contains($back[0], document.activeElement)) {
            $wrapper.find('button.turn-card').trigger('focus');
        }

        $card.toggleClass('pressed', flipped);

        setInert($front, flipped);
        setInert($back, !flipped);

        $wrapper.find('button.turn-card').attr('aria-expanded', flipped ? 'true' : 'false');

        updateScrollableTabindex($back.find('.bodytext'), flipped);
    }

    function flipboxTurn($card, force) {
        var flipped = (typeof force === 'boolean') ? force : !$card.hasClass('pressed');

        setFlipState($card, flipped);
    }

    function resetAllFlipBoxes(except) {
        $(FLIPBOX + ' .card-turn.pressed').each(function() {
            var $box = $(this);

            if (except && $box.is(except)) {
                return;
            }

            setFlipState($box, false);
            $box.removeClass('nce-mouseinside nce-pinned');
        });
    }

    // Klick und Tastaturbedienung (Enter/Leertaste auf button.turn-card loesen ebenfalls click aus)
    $(document).on('click', FLIPBOX, function(e) {
        if ($(e.target).closest('.ttgCopyright').length) {
            return;
        }

        var $card = $(this).find('.card-turn');
        var flipped = !$card.hasClass('pressed');

        resetAllFlipBoxes($card);
        flipboxTurn($card, flipped);

        // bewusst umgedrehte Karten bleiben offen, bis erneut geklickt oder Escape gedrueckt wird
        $card.toggleClass('nce-pinned', flipped);
    });

    $(document).on('mouseenter', FLIPBOX, function(e) {
        if (isTouchDevice()) {
            return;
        }

        if ($(e.target).closest('.ttgCopyright').length) {
            return;
        }

        var $card = $(this).find('.card-turn');

        $card.addClass('nce-mouseinside');
        resetAllFlipBoxes($card);
        flipboxTurn($card, true);
    });

    $(document).on('mouseleave', FLIPBOX, function() {
        if (isTouchDevice()) {
            return;
        }

        var $card = $(this).find('.card-turn');

        $card.removeClass('nce-mouseinside');

        if ($card.hasClass('nce-pinned')) {
            return;
        }

        flipboxTurn($card, false);
    });

    // Escape schliesst jede offene Karte, auch die nur per Hover geoeffnete (WCAG 1.4.13)
    $(document).on('keydown', function(e) {
        if (e.key !== 'Escape' && e.key !== 'Esc' && e.which !== 27) {
            return;
        }

        var $openCards = $(FLIPBOX + ' .card-turn.pressed');

        if (!$openCards.length) {
            return;
        }

        $openCards.each(function() {
            var $card = $(this);

            setFlipState($card, false);
            $card.removeClass('nce-mouseinside nce-pinned');
        });
    });
}(jQuery));
